import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "XlTubiao"
});
const _hoisted_1 = {
  t: "1664508640262",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "16076",
  width: "200",
  height: "200"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M78.392889 49.777778h49.777778a28.444444 28.444444 0 0 1 28.444444 28.444444v872.106667H78.392889a28.444444 28.444444 0 0 1-28.444445-28.444445V78.222222a28.444444 28.444444 0 0 1 28.444445-28.444444z",
  fill: "currentColor",
  "p-id": "16077"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M49.777778 953.457778v-78.165334h896a28.444444 28.444444 0 0 1 28.444444 28.444445v49.777778a28.444444 28.444444 0 0 1-28.444444 28.444444H78.222222a28.444444 28.444444 0 0 1-28.444444-28.444444zM373.248 585.784889a28.444444 28.444444 0 0 1 28.444444 28.444444v154.168889a28.444444 28.444444 0 0 1-28.444444 28.444445H298.097778a28.444444 28.444444 0 0 1-28.444445-28.444445v-154.168889a28.444444 28.444444 0 0 1 28.444445-28.444444H373.191111z m237.738667-369.379556a28.444444 28.444444 0 0 1 28.444444 28.444445v523.548444a28.444444 28.444444 0 0 1-28.444444 28.444445H535.779556a28.444444 28.444444 0 0 1-28.444445-28.444445V244.849778a28.444444 28.444444 0 0 1 28.444445-28.444445h75.207111z m237.681777 211.057778a28.444444 28.444444 0 0 1 28.444445 28.444445v312.490666a28.444444 28.444444 0 0 1-28.444445 28.444445h-75.150222a28.444444 28.444444 0 0 1-28.444444-28.444445V455.964444a28.444444 28.444444 0 0 1 28.444444-28.444444h75.150222z",
  fill: "currentColor",
  "p-id": "16078"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var xlTubiao = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xlTubiao as default };
